module.exports = __webpack_public_path__ + "b2257b31a3f407946baae51a27d397ae.svg";